import React from 'react';
import FormatListBulleted from '@material-ui/icons/FormatListBulleted';
import UsaIcon from '../../usa/components/UsaIcon'
import Icon from '@material-ui/core/Icon';
import parse from 'html-react-parser'

// import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplicationsIcon';
import {cl, globs, constant, makeShortDayDateStr} from '../../components/utils/utils';
import {getDatapointName} from '../../usa/utils/utils'

class ConfigLogFeedEntry00 extends React.Component{
  constructor(props) {
    super(props);
//     cl(props)
  }
  
  result=(type)=>{
    cl(type)
  }

  render=()=>{
    let entry=this.props.parms.entry
//     cl(entry)
    let av=entry.avatar
    var path
    if(av){
      path=`${constant.expressUrl}/usa/images/avatars/uploads/${av[0]}/${av[1]}/${av[2]}/${av.substr(3)}.jpeg`
    }else{
      path=`${constant.expressUrl}/usa/images/avatars/stockAvatar.jpg`
    }
    let name=getDatapointName(entry.i)
    let dateStr=makeShortDayDateStr(entry.t)
    let desc=`<strong>${entry.category}: ${entry.subject}</strong>`
    return(
      <table><tbody>
      <tr><td><img src={path} height="40"/></td><td>
        <table><tbody>
        <tr><td>
        <Icon component={FormatListBulleted} style={{padding: 0, fontSize: 18, verticalAlign: "middle"}}/>
        <span style={{verticalAlign: "middle"}}>{dateStr}</span>
        </td></tr>
        <tr><td>{parse(desc)}
        <UsaIcon icon={"entry-More"} result={this.result}/>
        </td></tr>
        </tbody></table>
      </td></tr>
      </tbody></table>
    )
  }
}

export default ConfigLogFeedEntry00;
